export enum LanguageEnum {
    ENGLISH = 'en',
    CZECH = 'cz',
}
